import { useEffect, useState } from "react";
import { useGetTerminals } from "../../../../../hooks/api/queries/useTerminals";
import { useUrlSearch } from "../../../../../hooks/useUrlSearch";
import { useSelector } from "react-redux";

export const useInterswitchDevices = () => {
  const [isAddTerminal, setIsAddTerminal] = useState(false);
  const {
    search,
    queries,
    setSearch,
    gotoPage,
    filterBySearch,
    filterByStoreId,
  } = useUrlSearch();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const { data, isLoading: isLoadingTerminals } = useGetTerminals({ queries });

  useEffect(() => {
    if (!search.get("terminal_type")) {
      search.set("terminal_type", "INTERSWITCH");
      setSearch(search, { replace: true });
    }
  }, []);

  return {
    search,
    terminals: data?.data || [],
    metaDetails: data?.meta,
    isLoadingTerminals,
    isAddTerminal,
    storeList,
    setIsAddTerminal,
    gotoPage,
    filterBySearch,
    filterByStoreId,
  };
};
